export default __webpack_public_path__ + "static/media/look_up.e7b141b3.png";